// extracted by mini-css-extract-plugin
export default {"body":"styles_body__m1GPU","content":"styles_content__g4zxN","text":"styles_text__RDKD-","cta":"styles_cta__Ho92-","header":"styles_header__+Jlvt"};